import React, { FC } from 'react';

import { PaymentMethodInfoTypeFragment } from '@shared/api/graphql/generated';

import styles from './index.module.scss';

type CardLogoProps = {
  paymentMethod: PaymentMethodInfoTypeFragment;
};

const getCardBackgroundSrc = (cardType: string) => {
  switch (cardType) {
    case 'MasterCard': {
      return '/assets/img/bank_card_logos/logo_mastercard.svg';
    }
    case 'Visa': {
      return '/assets/img/bank_card_logos/logo_visa.svg';
    }
    case 'Mir': {
      return '/assets/img/bank_card_logos/logo_mir.svg';
    }
    case 'JCB': {
      return '/assets/img/bank_card_logos/logo_jcb.svg';
    }
    case 'AmericanExpress': {
      return '/assets/img/bank_card_logos/logo_am_ex.svg';
    }
    case 'DinersClub': {
      return '/assets/img/bank_card_logos/logo_diners_club.svg';
    }
    default: {
      return '/assets/img/bank_card_logos/logo_unknown.svg';
    }
  }
};

const CardLogo: FC<CardLogoProps> = ({ paymentMethod }) => (
  <div
    className={styles.CardLogoBackground}
    data-type={paymentMethod.cardType || 'empty'}>
    <img
      alt=""
      loading="lazy"
      className={styles.CardLogoBackgroundImage}
      src={getCardBackgroundSrc(paymentMethod.cardType)}
    />
    <div className={styles.CardLogoNumber}>{`**** ${paymentMethod.last4}`}</div>
    <div className={styles.CardLogoDate}>{`${paymentMethod.expiryMonth}/${paymentMethod.expiryYear}`}</div>
  </div>
);

export default React.memo(CardLogo);
